<template>
  <el-dialog class="impersonate" title="Saisir une signature de propale" :visible.sync="visible" :close-on-click-modal="false" @open="open" @close="close">
    <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">
      <el-form-item prop="id" style="margin-bottom: 0" label="Selectionnez une propale">
        <el-select v-model="form.id" class="form-control" placeholder="Propales du client / prospect">
          <el-option
            v-for="proposal in proposals"
            v-if="proposal.accepted_at === null"
            :key="proposal.id"
            :label="'Propale ' + proposalTypes.find(type => type.id === proposal.type_id).name + ' le ' + moment(proposal.created_at).format('L')"
            :value="proposal.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button type="success" v-on:click="submit()">Définir comme signée</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import nexus from '@db2b/nexus-js'
  import moment from 'moment'
  import ls from 'local-storage'
  import gravatar from 'vue-gravatar'
  import { events } from '../../services/event-bus.js'

  export default {
    name: 'sign-proposal-modal',
    components: {},
    data () {
      return {
        loading: false,
        visible: false,
        proposals: [],
        form: {
          id: null
        },
        fields: {
          validation: {}
        }
      }
    },
    created () {
      let self = this

      events.on('app/proposals/sign', ({proposals}) => {
        self.visible = true
        self.proposals = proposals
      })
    },
    computed: {
      proposalTypes () {
        return this.$store.getters['proposal_types/all']
      }
    },
    methods: {
      open () {

      },
      submit () {
        let self = this
        this.$refs['form'].validate((valid) => {
          if (valid) {
            self.$model.proposal.api().update(self.form.id, {
              accepted_at: moment()
            }).then(() => {
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      },
      close () {
        this.users = []
      }
    }
  }
</script>

<style>
  .impersonate .el-dialog {
    width: 420px;
  }

  .impersonate .row:first-child {
    margin-top: 0;
  }

  .impersonate .row {
    padding: 11px 1px;
    margin: 10px 0;
    cursor: pointer;
  }

  .impersonate .row:hover {
    padding: 10px 0px;
    border: 1px solid rgba(100, 176, 242, 0.6);
    background-color: rgba(100, 176, 242, 0.2);
  }

  .impersonate .row.imitator:hover {
    padding: 10px 0px;
    border: 1px solid rgba(27, 185, 154, 0.6);
    background-color: rgba(27, 185, 154, 0.2);
  }
</style>



// WEBPACK FOOTER //
// SignProposalModal.vue?4c229985